import { Box, Section } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import { OfferLetterTemplatesTable } from './OfferLetterTemplates'

export const OfferLetterTemplates = () => {
  return (
    <>
      <Section
        illustration="document-edit"
        title={i18n.t('ats.settings.templates.offer_letter_templates.title')}
        description={i18n.t('ats.settings.templates.offer_letter_templates.description')}
      />
      <Box paddingX="s64" paddingBottom="s32">
        <OfferLetterTemplatesTable />
      </Box>
    </>
  )
}
